import React from 'react';
import { NoteLegaliPage } from '../layouts/NoteLegaliPage';

const Page = () => <NoteLegaliPage />;
export default Page;
